import {
  PowerBIAnalytics,
  PremiumAnalyticsPages,
} from "@components/analytics/power-bi/power-bi-analytics";

/** Renders members analytics under members tab in analytics page*/
export function MembersAnalytics(): JSX.Element {
  return <PowerBIAnalytics pageDisplayName={PremiumAnalyticsPages.user} />;
}
